export default __webpack_public_path__ + "c845af5578f669706b130dece1ccf6f0.png";